import { Card, Table } from "antd";
import ListTable from "common/ListTable";

const formatIntWithCommas = (value) => {
  return parseInt(value)?.toLocaleString();
};

const formatFloatWithCommas = (value) => {
  return parseFloat(value).toFixed(2).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

const columnsSharingMerchandisers = [
  {
    title: "Dealing Merchandiser",
    dataIndex: "dealing_merchandiser",
    key: "dealing_merchandiser",
  },
  {
    title: "Buyer Name",
    dataIndex: "buyer",
    key: "buyer",
  },
  {
    title: "Swing Qty",
    dataIndex: "swing_qty",
    key: "swing_qty",
    align: "right",
    render: formatIntWithCommas,
  },
  {
    title: "CM/PC (USD)",
    dataIndex: "cm",
    key: "cm",
    align: "right",
    render: formatFloatWithCommas,
  },
  {
    title: "Income CM/USD",
    dataIndex: "income_cm_usd",
    key: "income_cm_usd",
    align: "right",
    render: formatFloatWithCommas,
  },
  {
    title: "CM Income (Taka)",
    dataIndex: "income_cm_taka",
    key: "income_cm_taka",
    align: "right",
    render: formatIntWithCommas,
  },
  {
    title: "Expenses (Taka)",
    dataIndex: "expenses_taka",
    key: "expenses_taka",
    align: "right",
    render: formatIntWithCommas,
  },
  {
    title: "Today's Est. Net Profit (Taka)",
    dataIndex: "today_net_profit",
    key: "today_net_profit",
    align: "right",
    render: (value) => {
      const numValue = parseFloat(value) || 0;
      return (
        <span style={{ color: numValue < 0 ? "red" : "green" }}>
          {formatIntWithCommas(Math.abs(numValue))}
          {numValue < 0 && " (Loss)"}
        </span>
      );
    },
  },
  {
    title: "Today's Projected Profit (Taka)",
    dataIndex: "today_projected_profit",
    key: "today_projected_profit",
    align: "right",
    render: (value) => value || "-",
  },
  {
    title: "Variance-Profit (Taka)",
    dataIndex: "variance_profit_taka",
    key: "variance_profit_taka",
    align: "right",
    render: (value) => value || "-",
  },
  {
    title: "Remarks",
    dataIndex: "remarks",
    key: "remarks",
    render: (value) => value || "-",
  },
];

export default function DailyProfitLossStatement({ todayData, loadingTodayData, endDateWatch }) {
  // Transform the API data to add keys for table rendering
  const rawData = Array.isArray(todayData) ? todayData : [];

  const tableData = rawData.map((item, index) => ({
    key: index.toString(),
    ...item,
  }));

  return (
    <Card
      title={`Daily Profit & (Loss) Statement of: (${endDateWatch?.format("DD-MMM-YY")})`}
      bordered={false}
      style={{
        boxShadow: "none",
      }}
    >
      <ListTable
        dataSource={tableData}
        columns={columnsSharingMerchandisers}
        pagination={false}
        bordered
        loading={loadingTodayData}
        emptyText="No records to show yet."
        title={() => "Daily Profit & Loss by Merchandisers: "}
        footer={() => "The expenses have been allocated on pc based on % of CM on total earned CM."}
        summary={(data) => {
          let totalSwingQty = 0;
          let totalCm = 0;
          let totalIncomeCmUsd = 0;
          let totalIncomeCmTaka = 0;
          let totalExpensesTaka = 0;
          let totalTodayNetProfit = 0;

          data.forEach((item) => {
            totalSwingQty += parseFloat(item.swing_qty) || 0;
            totalCm += parseFloat(item.cm) || 0;
            totalIncomeCmUsd += parseFloat(item.income_cm_usd) || 0;
            totalIncomeCmTaka += parseFloat(item.income_cm_taka) || 0;
            totalExpensesTaka += parseFloat(item.expenses_taka) || 0;
            totalTodayNetProfit += parseFloat(item.today_net_profit) || 0;
          });

          return (
            <>
              <Table.Summary.Row>
                <Table.Summary.Cell index={0}>Total</Table.Summary.Cell>
                <Table.Summary.Cell index={1}></Table.Summary.Cell>
                <Table.Summary.Cell align="right" index={2}>
                  {formatIntWithCommas(totalSwingQty)}
                </Table.Summary.Cell>
                <Table.Summary.Cell index={3} align="right">
                  {formatFloatWithCommas(data.length > 0 ? totalCm / data.length : 0)}
                </Table.Summary.Cell>
                <Table.Summary.Cell index={4} align="right">
                  {formatFloatWithCommas(totalIncomeCmUsd)}
                </Table.Summary.Cell>
                <Table.Summary.Cell index={5} align="right">
                  {formatIntWithCommas(totalIncomeCmTaka)}
                </Table.Summary.Cell>
                <Table.Summary.Cell index={6} align="right">
                  {formatIntWithCommas(totalExpensesTaka)}
                </Table.Summary.Cell>
                <Table.Summary.Cell index={7} align="right">
                  <span style={{ color: totalTodayNetProfit < 0 ? "red" : "green" }}>
                    {formatIntWithCommas(Math.abs(totalTodayNetProfit))}
                    {totalTodayNetProfit < 0 && " (Loss)"}
                  </span>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={8} align="right">
                  -
                </Table.Summary.Cell>
                <Table.Summary.Cell index={9} align="right">
                  -
                </Table.Summary.Cell>
                <Table.Summary.Cell index={10} align="right">
                  -
                </Table.Summary.Cell>
              </Table.Summary.Row>
            </>
          );
        }}
      />
    </Card>
  );
}
